"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3411],{

/***/ 70055:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "b": function() { return /* reexport */ BreadCrumbs; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/useTheme.js
var useTheme = __webpack_require__(2734);
// EXTERNAL MODULE: ./src/contexts/HighlightContext/Highlight.tsx
var Highlight = __webpack_require__(78958);
// EXTERNAL MODULE: ./src/components/Link/index.tsx
var Link = __webpack_require__(7500);
// EXTERNAL MODULE: ./node_modules/@mui/material/Breadcrumbs/Breadcrumbs.js + 3 modules
var Breadcrumbs = __webpack_require__(12963);
// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 16 modules
var esm = __webpack_require__(29769);
// EXTERNAL MODULE: ./src/contexts/AppContext/index.tsx + 6 modules
var AppContext = __webpack_require__(13560);
// EXTERNAL MODULE: ./node_modules/next-translate-routes/index.js
var next_translate_routes = __webpack_require__(18633);
;// CONCATENATED MODULE: ./src/utils/filter-breadcrumbs.ts

function filterBreadcrumbs(useCollectionCrumbs, data, locale, currentCollection) {
    var ref;
    var url = "".concat((ref = "https://fun.libero.it/") === null || ref === void 0 ? void 0 : ref.replace(/\/+$/, ""));
    var breadcrumbs = data;
    if (useCollectionCrumbs) {
        var filteredCrumbs = breadcrumbs.filter(function(crumb) {
            var ref;
            return !(crumb === null || crumb === void 0 ? void 0 : (ref = crumb.type) === null || ref === void 0 ? void 0 : ref.includes("category"));
        });
        if ((currentCollection === null || currentCollection === void 0 ? void 0 : currentCollection.name) && (currentCollection === null || currentCollection === void 0 ? void 0 : currentCollection.slug)) {
            return filteredCrumbs.map(function(crumb) {
                var translatedCollection = (0,next_translate_routes.translateUrl)("/collection/".concat(crumb.code), locale);
                if (crumb.path.includes(translatedCollection)) {
                    return {
                        href: "".concat(url).concat((0,next_translate_routes.translateUrl)("/collection/".concat(currentCollection.slug), locale)),
                        path: "".concat((0,next_translate_routes.translateUrl)("/collection/".concat(currentCollection.slug), locale)),
                        name: currentCollection.name
                    };
                }
                return crumb;
            });
        }
        return filteredCrumbs;
    } else {
        return breadcrumbs.filter(function(crumb) {
            var translatedCollection = (0,next_translate_routes.translateUrl)("/collection/".concat(crumb.code), locale);
            return !crumb.path.includes(translatedCollection);
        });
    }
}

;// CONCATENATED MODULE: ./src/components/BreadCrumbs/BreadCrumbs.tsx











var BreadCrumbs_Link = /*#__PURE__*/ react.forwardRef(function(props, ref) {
    return (0,Highlight/* useHighlightHandlers */.R)(Link/* Link */.r, (0,_object_spread/* default */.Z)({
        forwardedRef: ref
    }, props));
});
function BreadCrumbs(props) {
    var appContext = (0,AppContext/* useAppContext */.bp)();
    var t = (0,esm/* useTranslation */.$G)([
        "common",
        "breadcrumb"
    ]).t;
    var breadcrumbFilter = props.breadcrumbs.map(function(breadcrumb) {
        return breadcrumb.path === "/" ? (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, breadcrumb), {
            name: t("breadcrumb:home")
        }) : breadcrumb;
    });
    var currentCollection = appContext.useCollectionCrumbs().currentCollection;
    var ref = appContext.useConfig(), languageCode = ref.languageCode, componentOptions = ref.componentOptions;
    var breadcrumbs = filterBreadcrumbs(componentOptions.component_use_collection_crumbs || false, breadcrumbFilter, languageCode, currentCollection);
    var theme = (0,useTheme/* default */.Z)();
    var crumbRefs = react.useRef([]);
    // Todo: Fix crumbRefs.current typescript problem.
    // @ts-ignore
    crumbRefs.current = breadcrumbs.map(function(crumb, index) {
        var _index;
        // @ts-ignore
        return (_index = crumbRefs.current[index]) !== null && _index !== void 0 ? _index : /*#__PURE__*/ react.createRef();
    });
    if (!(props === null || props === void 0 ? void 0 : props.hidden)) return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Breadcrumbs/* default */.Z, {
        "aria-label": "breadcrumb",
        sx: {
            margin: theme.spacing(2, 0)
        },
        children: breadcrumbs.map(function(crumb, index) {
            return breadcrumbs[breadcrumbs.length - 1] ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(BreadCrumbs_Link, {
                // @ts-ignore
                ref: crumbRefs.current[index],
                underline: "hover",
                color: "text.primary",
                href: crumb.path,
                "aria-current": "page",
                variant: "body2",
                sx: {
                    textTransform: "none"
                },
                children: crumb.name === "Home" ? t("home", "Home") : crumb.name
            }, index) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(BreadCrumbs_Link, {
                // @ts-ignore
                ref: crumbRefs.current[index],
                underline: "hover",
                color: "inherit",
                href: crumb.path,
                variant: "body2",
                sx: {
                    textTransform: "none"
                },
                children: crumb.name
            }, index);
        })
    });
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {});
}

;// CONCATENATED MODULE: ./src/components/BreadCrumbs/index.ts



/***/ }),

/***/ 95073:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "T": function() { return /* reexport */ ImageLoaderWrapper; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
;// CONCATENATED MODULE: ./src/utils/is-valid-url.ts
var isValidUrl = function(url) {
    // Check if the url is a valid url or not.
    return /^https?:\/\//.test(url || "");
};

// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 2 modules
var emotion_styled_browser_esm = __webpack_require__(16829);
;// CONCATENATED MODULE: ./src/components/ImageLoaderWrapper/ImageLoaderWrapper.tsx







/**
 * Calculates the proper height of an image with a custom width, preserving the original aspect ratio.
 *
 * @param originalHeight
 * @param originalWidth
 * @param newWidth
 */ function determineNewHeight(originalHeight, originalWidth, newWidth) {
    return Math.ceil(originalHeight / originalWidth * newWidth);
}
var ImageContainer = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)((image_default()), {
    target: "epyx9ne0"
})(function(param) {
    var theme = param.theme;
    return {
        objectFit: "cover"
    };
});
var ImageLoaderWrapper = function(props) {
    var height = props.height, width = props.width, grayscale = props.grayscale, format = props.format, layout = props.layout, alt = props.alt, _rszHeight = props.rszHeight, rszHeight = _rszHeight === void 0 ? true : _rszHeight, other = (0,_object_without_properties/* default */.Z)(props, [
        "height",
        "width",
        "grayscale",
        "format",
        "layout",
        "alt",
        "rszHeight"
    ]);
    var loader = function(loaderProps) {
        var q = loaderProps.quality, w = loaderProps.width, src = loaderProps.src;
        // TODO: Check if the provided src is a valid url or not, if yes return it directly.
        var validUrl = isValidUrl(src.replace(/\/+$/, "").replace("/media/", ""));
        // Can find the query properties here;
        // https://gitlab.azerdev.com/huz.byorbit/huz-media/-/blob/master/src/asset/index.js
        // Todo: HUZ2ERA-1106 - Seems our media server won't allow us to resize webp assets by ratio operation.
        // let url = `${src.replace(/\/+$/, '')}/?qty=${q || 75}&fmt=${format || 'webp'}&ar[r]=${width}x${height}&ar[w]=${w}`;
        // let url = `${src.replace(/\/+$/, '')}/?qty=${q || 75}&fmt=${format || 'webp'}&rsz[w]=${w}`;
        var url = "".concat(src.replace(/\/+$/, ""), "/?fmt=").concat(format || "webp", "&rsz");
        // if (rszHeight) {
        //   url += `&rsz[h]=${determineNewHeight(height, width, w)}`;
        // }
        if (grayscale) url += "&gsc=".concat(grayscale);
        // TODO: Remove the conditional logic after updating all the existing sites.
        return validUrl && src.includes("https://media-aws-dev.byorbit.com") ? src.replace("/media/", "") : validUrl ? src.replace("/media/", "").replace(/\/+$/, "") : url;
    };
    // Make sure we don't pass width and height when layout is set to 'fill'. Refer to Next/image docs.
    return layout === "fill" ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ImageContainer, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, other), {
        alt: alt,
        layout: layout,
        loader: loader,
        height: "100%"
    })) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ImageContainer, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, other), {
        alt: alt,
        width: width,
        height: height,
        loader: loader
    }));
};

;// CONCATENATED MODULE: ./src/components/ImageLoaderWrapper/index.ts



/***/ }),

/***/ 80830:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "z": function() { return /* reexport */ PaperColorElevation; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 2 modules
var emotion_styled_browser_esm = __webpack_require__(16829);
// EXTERNAL MODULE: ./node_modules/@mui/system/esm/colorManipulator.js + 1 modules
var colorManipulator = __webpack_require__(8423);
// EXTERNAL MODULE: ./node_modules/@mui/material/Paper/Paper.js + 1 modules
var Paper = __webpack_require__(55113);
;// CONCATENATED MODULE: ./src/components/PaperColorElevation/PaperColorElevation.tsx







var PaperStyled = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)(Paper/* default */.Z, {
    target: "e4eo54y0"
})(function(param) {
    var theme = param.theme, elevation = param.elevation;
    return {
        boxShadow: theme.shadows[elevation || 1],
        backgroundColor: theme.palette.mode === "dark" ? (0,colorManipulator/* lighten */.$n)(theme.palette.background.paper, elevation ? elevation * 0.025 : 0) : (0,colorManipulator/* darken */._j)(theme.palette.background.paper, elevation ? elevation * 0.025 : 0)
    };
});
var PaperColorElevation = function(props) {
    var children = props.children, other = (0,_object_without_properties/* default */.Z)(props, [
        "children"
    ]);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PaperStyled, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, other), {
        children: children
    }));
};

;// CONCATENATED MODULE: ./src/components/PaperColorElevation/index.ts



/***/ }),

/***/ 61546:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "D": function() { return /* reexport */ Title; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 2 modules
var emotion_styled_browser_esm = __webpack_require__(16829);
// EXTERNAL MODULE: ./src/contexts/CursorContext/Cursor.tsx
var Cursor = __webpack_require__(52746);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/useTheme.js
var useTheme = __webpack_require__(2734);
;// CONCATENATED MODULE: ./src/components/Title/@editor/index.ts


var useEditorHandlers = function(name) {
    var theme = (0,useTheme/* default */.Z)();
    return (0,Cursor/* useCursorHandlers */.h)({
        name: name,
        styles: [
            {
                name: "theme_component_title_color",
                label: "General text color",
                type: "color",
                default: theme.palette.text.primary
            },
            {
                name: "theme_component_title_title_color",
                label: "Title text color",
                type: "color",
                default: theme.palette.text.primary
            },
            {
                name: "theme_component_title_link_hover_color",
                label: "Link text hover color",
                type: "color",
                default: theme.palette.action.hover
            },
            {
                name: "theme_component_title_link_active_color",
                label: "Link text active color",
                type: "color",
                default: theme.palette.action.active
            },
            {
                name: "theme_component_card_title_font_size",
                label: "Title font size",
                endAdornment: "px",
                type: "text",
                default: theme.typography.h2.fontSize
            },
            // 
            // {
            //   name: 'theme_component_title_padding',
            //   label: 'Padding',
            //   type: 'text',
            //   default: theme.spacing(1, 2),
            //   helperText: 'Define as top right left bottom; e.g.: 2px 10px 5px 10px',
            // },
            {
                name: "theme_component_title_lg_padding",
                label: "Padding for large screens",
                type: "text",
                default: theme.spacing(1, 2),
                helperText: "Define as top right left bottom; e.g.: 2px 10px 5px 10px"
            },
            // {
            //   name: 'theme_component_title_justify_content',
            //   label: 'Justify content',
            //   type: 'select',
            //   default: 'space-between',
            //   options: ['flex-start', 'flex-end', 'center', 'space-between', 'space-around', 'space-evenly'],
            // },
            // {
            //   name: 'theme_component_title_align_items',
            //   label: 'Align items',
            //   type: 'select',
            //   default: 'center',
            //   options: ['flex-start', 'flex-end', 'center', 'baseline', 'stretch'],
            // },
            {
                name: "theme_component_title_border_bottom_width",
                label: "Border bottom width",
                type: "number",
                endAdornment: "px",
                default: 1
            },
            {
                name: "theme_component_title_border_bottom_color",
                label: "Border bottom color",
                type: "color",
                default: theme.palette.divider
            }, 
        ],
        configuration: []
    });
};

// EXTERNAL MODULE: ./src/contexts/HighlightContext/Highlight.tsx
var Highlight = __webpack_require__(78958);
// EXTERNAL MODULE: ./node_modules/@mui/material/Typography/Typography.js + 1 modules
var Typography = __webpack_require__(15861);
// EXTERNAL MODULE: ./node_modules/@mui/material/Container/Container.js + 2 modules
var Container = __webpack_require__(53156);
;// CONCATENATED MODULE: ./src/components/Title/Title.tsx










var Title_Typography = /*#__PURE__*/ react.forwardRef(function(props, ref) {
    return (0,Highlight/* useHighlightHandlers */.R)(Typography/* default */.Z, (0,_object_spread/* default */.Z)({
        forwardedRef: ref
    }, props));
});
var Root = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)(Container/* default */.Z, {
    target: "e15gjue10"
})(function(param) {
    var theme = param.theme;
    return {
        borderBottomWidth: theme.theme_component_title_border_bottom_width ? "".concat(theme.theme_component_title_border_bottom_width, "px") : 0,
        borderBottomStyle: "solid",
        borderBottomColor: theme.theme_component_title_border_bottom_color || theme.palette.divider,
        color: theme.theme_component_title_color || theme.palette.text.primary,
        paddingTop: theme.spacing(1.25),
        paddingBottom: theme.spacing(1.25),
        textTransform: "capitalize"
    };
});
var TypographyStyled = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)(Title_Typography, {
    target: "e15gjue11"
})(function(param) {
    var theme = param.theme;
    return {
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
        alignItems: "center",
        textTransform: "none",
        color: theme.theme_component_title_title_color || "inherit",
        "& > a": {
            color: theme.theme_component_title_title_color || theme.palette.text.primary,
            "&:hover": {
                color: theme.theme_component_title_link_hover_color || theme.palette.action.hover
            },
            "&:active": {
                color: theme.theme_component_title_link_active_color || theme.palette.action.active
            }
        }
    };
});
var Title = function(props) {
    var disableGutters = props.disableGutters, children = props.children, className = props.className, style = props.style, childStyle = props.childStyle, other = (0,_object_without_properties/* default */.Z)(props, [
        "disableGutters",
        "children",
        "className",
        "style",
        "childStyle"
    ]);
    var titleRef = react.useRef(null);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Root, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        maxWidth: false,
        disableGutters: disableGutters,
        className: className,
        style: style
    }, useEditorHandlers("Title")), {
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TypographyStyled, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
            ref: titleRef,
            style: childStyle
        }, other), {
            children: children
        }))
    }));
};

;// CONCATENATED MODULE: ./src/components/Title/index.ts



/***/ }),

/***/ 3604:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "t": function() { return /* reexport */ CollectionA; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 2 modules
var emotion_styled_browser_esm = __webpack_require__(16829);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/react-intersection-observer/index.mjs
var react_intersection_observer = __webpack_require__(42708);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/useTheme.js
var useTheme = __webpack_require__(2734);
// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 16 modules
var esm = __webpack_require__(29769);
// EXTERNAL MODULE: ./src/contexts/HighlightContext/Highlight.tsx
var Highlight = __webpack_require__(78958);
// EXTERNAL MODULE: ./node_modules/@mui/material/Typography/Typography.js + 1 modules
var Typography = __webpack_require__(15861);
// EXTERNAL MODULE: ./node_modules/@mui/material/useMediaQuery/useMediaQuery.js
var useMediaQuery = __webpack_require__(98396);
// EXTERNAL MODULE: ./node_modules/@mui/material/Container/Container.js + 2 modules
var Container = __webpack_require__(53156);
// EXTERNAL MODULE: ./src/contexts/AppContext/index.tsx + 6 modules
var AppContext = __webpack_require__(13560);
// EXTERNAL MODULE: ./src/utils/ads-request.ts
var ads_request = __webpack_require__(18505);
// EXTERNAL MODULE: ./src/components/Card/index.ts + 22 modules
var Card = __webpack_require__(74821);
// EXTERNAL MODULE: ./src/components/Title/index.ts + 2 modules
var Title = __webpack_require__(61546);
// EXTERNAL MODULE: ./src/components/PaperColorElevation/index.ts + 1 modules
var PaperColorElevation = __webpack_require__(80830);
// EXTERNAL MODULE: ./src/components/BreadCrumbs/index.ts + 2 modules
var BreadCrumbs = __webpack_require__(70055);
// EXTERNAL MODULE: ./src/types/enum.ts
var types_enum = __webpack_require__(95753);
// EXTERNAL MODULE: ./src/contexts/CursorContext/index.tsx
var CursorContext = __webpack_require__(15888);
;// CONCATENATED MODULE: ./src/containers/CollectionA/CollectionA.tsx






















var AdvertisementSlot = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 9918).then(__webpack_require__.bind(__webpack_require__, 29918)).then(function(mod) {
        return mod.AdvertisementSlot;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(29918)
            ];
        }
    },
    ssr: false
});
var CollectionSection = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 7839).then(__webpack_require__.bind(__webpack_require__, 67839)).then(function(mod) {
        return mod.CollectionSection;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(67839)
            ];
        }
    },
    ssr: false
});
var CarouselList = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(4386), __webpack_require__.e(4905), __webpack_require__.e(7865)]).then(__webpack_require__.bind(__webpack_require__, 24905)).then(function(mod) {
        return mod.CarouselList;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(24905)
            ];
        }
    },
    ssr: false
});
var CollectionA_Typography = /*#__PURE__*/ react.forwardRef(function(props, ref) {
    return (0,Highlight/* useHighlightHandlers */.R)(Typography/* default */.Z, (0,_object_spread/* default */.Z)({
        forwardedRef: ref
    }, props));
});
var Root = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e3bm5bx0"
})(function(param) {
    var theme = param.theme;
    return {
        display: "flex",
        flexDirection: "column",
        paddingBottom: theme.spacing(2)
    };
});
var AdCollectionContainer = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e3bm5bx1"
})(function(param) {
    var theme = param.theme;
    var _obj;
    return _obj = {
        display: "grid",
        padding: theme.spacing(1, 2, 0),
        gap: theme.spacing(2),
        gridTemplateColumns: "auto",
        gridTemplateAreas: "\n        'advertisement advertisement'\n        'gameA gameB'"
    }, (0,_define_property/* default */.Z)(_obj, theme.breakpoints.up("md"), {
        gridTemplateColumns: "auto 512px",
        gridTemplateAreas: "\n        'advertisement gameA'\n        'advertisement gameB'"
    }), (0,_define_property/* default */.Z)(_obj, theme.breakpoints.up("lg"), {
        padding: theme.spacing(0, 2, 0),
        gridTemplateColumns: "calc(970px + ".concat(theme.spacing(2), ") 1fr"),
        gridTemplateAreas: "\n        'advertisement gameA'\n        'advertisement gameB'"
    }), (0,_define_property/* default */.Z)(_obj, theme.breakpoints.up(1600), {
        gridTemplateColumns: "auto 512px"
    }), (0,_define_property/* default */.Z)(_obj, theme.breakpoints.up("xl"), {
        gridTemplateColumns: "calc(970px + ".concat(theme.spacing(2), ") 1fr 1fr"),
        gridTemplateAreas: "\n        'advertisement gameA gameB'"
    }), _obj;
});
var AdvertisementSlotStyled = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)(AdvertisementSlot, {
    target: "e3bm5bx2"
})(function(param) {
    var theme = param.theme;
    return {
        boxShadow: theme.shadows[0]
    };
});
var CardSkeletonStyled = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)(Card/* CardSkeleton */.q4, {
    target: "e3bm5bx3"
})(function(param) {
    var theme = param.theme;
    return {
        boxShadow: theme.shadows[0]
    };
});
var CardSkeletonGrid = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)(Card/* CardSkeleton */.q4, {
    target: "e3bm5bx4"
})(function(param) {
    var theme = param.theme;
    return {
        boxShadow: theme.shadows[0],
        aspectRatio: "4/3"
    };
});
var AdCollectionBox = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)(PaperColorElevation/* PaperColorElevation */.z, {
    target: "e3bm5bx5"
})(function(props) {
    var theme = props.theme, box = props.box;
    var styles = {};
    switch(box){
        case 1:
            styles = (0,_define_property/* default */.Z)({
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                textAlign: "center",
                gridArea: "advertisement",
                boxShadow: theme.shadows[0]
            }, theme.breakpoints.up(370), {
                // Making sure 336x280 ad will fit, and after we have a nice padding.
                padding: theme.spacing(2)
            });
            break;
        case 2:
            styles = {
                gridArea: "gameA",
                boxShadow: theme.shadows[0]
            };
            break;
        case 3:
            styles = {
                gridArea: "gameB",
                boxShadow: theme.shadows[0]
            };
            break;
    }
    return styles;
});
var CollectionContainer = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e3bm5bx6"
})(function(param) {
    var theme = param.theme;
    var _obj;
    return _obj = {
        display: "grid",
        padding: theme.spacing(0, 2, 1),
        gap: theme.spacing(2),
        gridTemplateColumns: "repeat(2, minmax(0, 1fr))",
        gridTemplateRows: "auto",
        gridTemplateAreas: "\n        'A A'\n        'B C'\n        'D D'\n        'E F'\n        'G G'\n        'H I'\n        'J K'"
    }, (0,_define_property/* default */.Z)(_obj, theme.breakpoints.up("sm"), {
        gridTemplateColumns: "repeat(4, minmax(0, 1fr))",
        gridTemplateRows: "auto",
        gridTemplateAreas: "\n        'A A B C'\n        'A A E F'\n        'H I D D'\n        'J K D D'\n        'G G . .'"
    }), (0,_define_property/* default */.Z)(_obj, theme.breakpoints.up("md"), {
        gridTemplateColumns: "repeat(10, minmax(0, 1fr))",
        gridTemplateRows: "repeat(2, 1fr)",
        gridTemplateAreas: "\n        'A A B C D D E F G G'\n        'A A H I D D J K G G'"
    }), (0,_define_property/* default */.Z)(_obj, theme.breakpoints.up("lg"), {
        padding: theme.spacing(2)
    }), _obj;
});
var CollectionBox = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e3bm5bx7"
})(function(props) {
    var box = props.box;
    var styles = {};
    switch(box){
        case 1:
            styles = {
                gridArea: "A"
            };
            break;
        case 2:
            styles = {
                gridArea: "B"
            };
            break;
        case 3:
            styles = {
                gridArea: "C"
            };
            break;
        case 4:
            styles = {
                gridArea: "D"
            };
            break;
        case 5:
            styles = {
                gridArea: "E"
            };
            break;
        case 6:
            styles = {
                gridArea: "F"
            };
            break;
        case 7:
            styles = {
                gridArea: "G"
            };
            break;
        case 8:
            styles = {
                gridArea: "H"
            };
            break;
        case 9:
            styles = {
                gridArea: "I"
            };
            break;
        case 10:
            styles = {
                gridArea: "J"
            };
            break;
        case 11:
            styles = {
                gridArea: "K"
            };
            break;
    }
    return styles;
});
var HeaderTop = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)(Container/* default */.Z, {
    target: "e3bm5bx8"
})(function(param) {
    var theme = param.theme;
    return (0,_define_property/* default */.Z)({}, theme.breakpoints.down("md"), {
        display: "none"
    });
});
var HeaderBottom = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)(Container/* default */.Z, {
    target: "e3bm5bx9"
})(function(param) {
    var theme = param.theme;
    return (0,_define_property/* default */.Z)({}, theme.breakpoints.up("md"), {
        display: "none"
    });
});
var CollectionA = function(props) {
    var ref;
    var title = props.title, body = props.body, collection = props.collection, global = props.global, pageContext = props.pageContext;
    var t = (0,esm/* useTranslation */.$G)("collection_a").t;
    var ref1 = (0,react_intersection_observer/* useInView */.YD)(), ref2 = ref1.ref, inView = ref1.inView;
    var router = (0,next_router.useRouter)();
    var appContext = (0,AppContext/* useAppContext */.bp)();
    var enabled = (0,CursorContext/* useCursorContext */.r)().enabled;
    var ref3 = appContext.useConfig(), assetUrl = ref3.assetUrl, componentOptions = ref3.componentOptions;
    var theme = (0,useTheme/* default */.Z)();
    var sm = (0,useMediaQuery/* default */.Z)(theme.breakpoints.up("sm"));
    var lg = (0,useMediaQuery/* default */.Z)(theme.breakpoints.up("lg"));
    var banners = [
        "idhb-middle-970"
    ];
    var descriptionTopRef = react.useRef(null);
    var descriptionBottomRef = react.useRef(null);
    var contentMainSection = (0,_to_consumable_array/* default */.Z)(Array(11)).map(function(slot, index) {
        var ref;
        return (ref = collection.games) === null || ref === void 0 ? void 0 : ref[index];
    });
    var contentAdSection = (0,_to_consumable_array/* default */.Z)(Array(2)).map(function(slot, index) {
        var ref, ref1;
        return (ref1 = (ref = collection.games) === null || ref === void 0 ? void 0 : ref.slice(contentMainSection.length, contentMainSection.length + 2)) === null || ref1 === void 0 ? void 0 : ref1[index];
    });
    var contentMoreSection = ((ref = collection.games) === null || ref === void 0 ? void 0 : ref.slice(contentAdSection.length + contentMainSection.length)) || [];
    var cardType = componentOptions === null || componentOptions === void 0 ? void 0 : componentOptions.component_game_carousel_card_type;
    react.useEffect(function() {
        (0,ads_request.adsRequest)(banners);
    }, []);
    react.useEffect(function() {
        var events = router.events;
        var handleRouteChange = function() {
            (0,ads_request.adsRequest)(banners);
        };
        events.on("routeChangeComplete", handleRouteChange);
        events.on("hashChangeComplete", handleRouteChange);
        return function() {
            events.off("routeChangeComplete", handleRouteChange);
            events.off("hashChangeComplete", handleRouteChange);
        };
    }, [
        router
    ]);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Container/* default */.Z, {
                maxWidth: false,
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(BreadCrumbs/* BreadCrumbs */.b, {
                    breadcrumbs: pageContext.breadcrumbs,
                    hidden: componentOptions === null || componentOptions === void 0 ? void 0 : componentOptions.component_breadcrumb_hidden
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Root, {
                ref: ref2,
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(HeaderTop, {
                        maxWidth: false,
                        children: [
                            title && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Title/* Title */.D, {
                                component: "h1",
                                variant: "h1",
                                disableGutters: true,
                                children: title
                            }),
                            body && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CollectionA_Typography, {
                                ref: descriptionTopRef,
                                variant: "body1",
                                sx: {
                                    marginTop: theme.spacing(1.25),
                                    marginBottom: theme.spacing(1)
                                },
                                children: body
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CollectionContainer, {
                        children: contentMainSection.map(function(item, index) {
                            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CollectionBox, {
                                box: index,
                                children: item ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Card/* Card */.Zb, {
                                    sx: {
                                        display: "flex"
                                    },
                                    href: "".concat(enabled ? "#" : "".concat(item.slug)),
                                    src: "".concat(assetUrl).concat([
                                        1,
                                        4,
                                        7
                                    ].includes(index) ? item.images.cover4x3 || item.images.cover : item.images.cover16x9 || item.images.cover, "/"),
                                    alt: item.name || "Cover",
                                    template: types_enum/* CardTypeEnum.SIMPLE */.mq.SIMPLE,
                                    title: item.name || undefined,
                                    width: [
                                        1,
                                        4,
                                        7
                                    ].includes(index) ? 400 : componentOptions.component_card_width || 512,
                                    height: [
                                        1,
                                        4,
                                        7
                                    ].includes(index) ? 300 : componentOptions.component_card_height || 288,
                                    sizes: [
                                        1,
                                        4,
                                        7
                                    ].includes(index) ? "".concat(theme.breakpoints.up("md").replace("@media ", ""), " 20vw, ").concat(theme.breakpoints.up("sm").replace("@media ", ""), " 50vw, 100vw") : "".concat(theme.breakpoints.up("md").replace("@media ", ""), " 10vw, ").concat(theme.breakpoints.up("sm").replace("@media ", ""), " 25vw, 50vw"),
                                    priority: index === 1,
                                    layout: "responsive"
                                }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CardSkeletonGrid, {
                                    elevation: 1
                                })
                            }, index);
                        })
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(AdCollectionContainer, {
                        children: [
                            !componentOptions.component_ads_disabled && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AdCollectionBox, {
                                box: 1,
                                elevation: 1,
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AdvertisementSlotStyled, {
                                    elevation: 2,
                                    slotIdentifier: "idhb-middle-970",
                                    variant: lg ? "970x250" : sm ? "336x280" : "300x250"
                                })
                            }),
                            contentAdSection.map(function(game, index) {
                                /*#__PURE__*/ return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AdCollectionBox, {
                                    box: index + 2,
                                    elevation: 0,
                                    children: (game === null || game === void 0 ? void 0 : game.id) ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Card/* Card */.Zb, {
                                        sx: {
                                            display: "flex"
                                        },
                                        href: "".concat(game.slug),
                                        src: "".concat(assetUrl).concat(game.images.cover16x9 || game.images.cover, "/"),
                                        alt: game.name || "Cover",
                                        title: game.name || undefined,
                                        template: types_enum/* CardTypeEnum.SIMPLE */.mq.SIMPLE,
                                        width: componentOptions.component_card_width || 512,
                                        height: componentOptions.component_card_height || 288,
                                        sizes: "".concat(theme.breakpoints.up("lg").replace("@media ", ""), " 20vw, 50vw"),
                                        layout: "responsive"
                                    }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CardSkeletonStyled, {
                                        elevation: 1
                                    })
                                }, index);
                            })
                        ]
                    }),
                    inView && contentMoreSection.length > 0 && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CollectionSection, {
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Title/* Title */.D, {
                                component: "h2",
                                variant: "h2",
                                children: t("more_header", "More")
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CarouselList, {
                                padding: theme.spacing(2),
                                items: contentMoreSection,
                                cardOptions: {
                                    width: componentOptions.component_card_width || 512,
                                    height: componentOptions.component_card_height || 288,
                                    sizes: "(min-width:1200px) 16.666vw, (min-width:900px) 25vw, (min-width:600px) 33.333vw, 50vw",
                                    layout: "responsive"
                                }
                            })
                        ]
                    }),
                    inView && ((global === null || global === void 0 ? void 0 : global.collections) || []).map(function(collection, index) {
                        return collection.games.length > 0 && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CollectionSection, {
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Title/* Title */.D, {
                                    component: "h2",
                                    variant: "h2",
                                    children: collection.name
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CarouselList, {
                                    padding: theme.spacing(2),
                                    items: collection.games,
                                    cardOptions: {
                                        width: componentOptions.component_card_width || 512,
                                        height: componentOptions.component_card_height || 288,
                                        sizes: "(min-width:1200px) 16.666vw, (min-width:900px) 25vw, (min-width:600px) 33.333vw, 50vw",
                                        layout: "responsive"
                                    }
                                })
                            ]
                        }, "".concat(collection.id).concat(index));
                    }),
                    inView && Array.isArray(global.popular) && global.popular.length > 0 && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CollectionSection, {
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Title/* Title */.D, {
                                component: "h2",
                                variant: "h2",
                                children: t("popular_header", "Popular")
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CarouselList, {
                                padding: theme.spacing(2),
                                items: global.popular,
                                cardOptions: {
                                    width: componentOptions.component_card_width || 512,
                                    height: componentOptions.component_card_height || 288,
                                    sizes: "(min-width:1200px) 16.666vw, (min-width:900px) 25vw, (min-width:600px) 33.333vw, 50vw",
                                    layout: "responsive"
                                }
                            })
                        ]
                    }),
                    inView && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CollectionSection, {
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Title/* Title */.D, {
                                component: "h2",
                                variant: "h2",
                                children: t("latest_header", "Latest")
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CarouselList, {
                                padding: theme.spacing(2),
                                items: global === null || global === void 0 ? void 0 : global.latest,
                                cardOptions: {
                                    width: componentOptions.component_card_width || 512,
                                    height: componentOptions.component_card_height || 288,
                                    sizes: "(min-width:1200px) 16.666vw, (min-width:900px) 25vw, (min-width:600px) 33.333vw, 50vw",
                                    layout: "responsive"
                                }
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(HeaderBottom, {
                        maxWidth: false,
                        sx: {
                            marginTop: theme.spacing(2)
                        },
                        children: [
                            title && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Title/* Title */.D, {
                                component: "h1",
                                variant: "h1",
                                disableGutters: true,
                                children: title
                            }),
                            body && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CollectionA_Typography, {
                                ref: descriptionBottomRef,
                                variant: "body1",
                                sx: {
                                    marginTop: theme.spacing(1.25)
                                },
                                children: body
                            })
                        ]
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/containers/CollectionA/index.ts



/***/ }),

/***/ 78958:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "R": function() { return /* binding */ useHighlightHandlers; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(99534);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(35944);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _mui_material_styles__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2734);
/* harmony import */ var _index__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(54794);







// Todo: Have a hard time setting the type for Component, as it can be Mui Typography or our own Link component.
var useHighlightHandlers = function(Component, props) {
    var enabledVariants = (0,_index__WEBPACK_IMPORTED_MODULE_1__/* .useHighlightContext */ .A)().enabledVariants;
    var forwardedRef = props.forwardedRef, variant = props.variant, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(props, [
        "forwardedRef",
        "variant"
    ]);
    var theme = (0,_mui_material_styles__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)();
    var element = null;
    // Todo: Not sure how to resolve this missing current ts warning.
    // @ts-ignore
    if (forwardedRef && (forwardedRef === null || forwardedRef === void 0 ? void 0 : forwardedRef.current)) {
        // Todo: Not sure how to resolve this missing current ts warning.
        // @ts-ignore
        element = forwardedRef.current;
    }
    if (element && variant && Array.isArray(enabledVariants)) {
        if (enabledVariants.includes(variant)) {
            element.style.outline = "2px dotted ".concat(theme.palette.info.main);
            element.style.outlineOffset = "-2px";
            element.style.position = "relative";
            if (!element.querySelector(".typographyBadge")) {
                var badge = document.createElement("div");
                badge.classList.add("typographyBadge");
                badge.style.position = "absolute";
                badge.style.top = theme.spacing(-0.5);
                badge.style.right = theme.spacing(-0.5);
                badge.style.backgroundColor = theme.palette.info.main;
                badge.style.borderRadius = "".concat(theme.shape.borderRadius, "px");
                badge.style.color = theme.palette.info.contrastText;
                badge.style.fontSize = "10px";
                badge.style.lineHeight = "10px";
                badge.style.padding = theme.spacing(0.5, 1);
                badge.style.boxShadow = theme.shadows[1];
                badge.style.textTransform = "capitalize";
                badge.innerText = [
                    "contained",
                    "text",
                    "outlined"
                ].includes(variant) ? "button" : variant;
                element.appendChild(badge);
            }
        } else {
            var ref;
            element.style.outline = "unset";
            (ref = element.querySelector(".typographyBadge")) === null || ref === void 0 ? void 0 : ref.remove();
        }
    }
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(Component, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, rest), {
        variant: variant,
        ref: forwardedRef
    }));
};


/***/ })

}]);